<template>
  <div id="footer" class="container-fluid">
    <div class="logo" style="width:200px;" >
      <img src="@/assets/img/logo_white.png" alt="logo图" style="width:200px;height:52.4px;" >
    </div>
   <!-- <p class="title">{{company}}</p> -->
    <p class="address_tel_fax">
      <!-- <span>{{address}}</span> -->
      <span>Tel：0755-61396813</span>
    </p>
    <p class="email_wx">
      <span>{{email}}：506971402@qq.com</span>
      <span>{{Wechat_ID}}：CC-45679</span>
    </p>
    <p class="copy">Copyright &copy; 2018 - {{ new Date().getFullYear() }}  <a target="_blank" href="https://beian.miit.gov.cn">粤ICP备2023101801号-5</a></p>

  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    var lang = localStorage.getItem("lang");

    switch(lang){
      case  "en":
        var company = "Shenzhen Zhongwang Information Technology Co., LTD";
        var address = "Address: 3703 Pengnian Plaza, No. 2002, Panbing Road, Jiabei Community, Nanhu Street, Luohu District, Shenzhen, Guangdong Province";
        var email   = "email";
        var Wechat_ID = "Wechat ID";
      break;
      case  "ru":
        var company = "Шеньшеньский шеньчжоу, intel LTD";
        var address = "Адрес: адрес: проживаемая в 2002 году улица кэбэй, south lake street, шаньдун, гуандун";
        var email   = "Почтов ящик";
        var Wechat_ID = "Микросигнал.";
      break;
      default:
        var company = "深圳市中望信息科技有限公司";
        var address = "地址：广东省深圳市罗湖区南湖街道嘉北社区嘉宾路2002号彭年广场4202";
        var email   = "邮箱";
        var Wechat_ID = "微信号";
      break;
    }


    return {
      company:company,
      address:address,
      email:email,Wechat_ID:Wechat_ID,
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue